const BurgerSvg = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.75 3.75H20.25V6H3.75V3.75Z'
        fill='#E9E6E6'
      />
      <path d='M5.25 6V3.75H3.75L3 6H5.25Z' fill='#E9E6E6' />
      <path d='M18.75 3.75V6H20.25L21 3.75H18.75Z' fill='#E9E6E6' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.75 18H20.25V20.25H3.75V18Z'
        fill='#E9E6E6'
      />
      <path d='M5.25 20.25V18H3.75L3 20.25H5.25Z' fill='#E9E6E6' />
      <path d='M18.75 18V20.25H20.25L21 18H18.75Z' fill='#E9E6E6' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.75 10.8825H20.25V13.1325H3.75V10.8825Z'
        fill='#E9E6E6'
      />
      <path d='M5.25 13.1325V10.8825H3.75L3 13.1325H5.25Z' fill='#E9E6E6' />
      <path d='M18.75 10.8825V13.1325H20.25L21 10.8825H18.75Z' fill='#E9E6E6' />
    </svg>
  );
};

export default BurgerSvg;
